import { Divider } from "@chakra-ui/react";
import { BaseBlockProps } from "./types";

export const DividerBlock = (_props: BaseBlockProps) => {
  return <Divider my="md" borderColor="border.default" />;
};
